var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "#CB9C1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_201_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9177 12.208C14.6377 12.208 12.9087 13.994 12.9087 16.3975C12.9087 18.7535 14.6567 20.587 16.9177 20.587C17.5067 20.587 18.1717 20.4255 18.6467 20.1405V17.908H16.0437V15.495H21.8007V21.4515C20.5372 22.563 18.8082 23.228 16.9177 23.228C12.8517 23.228 9.73571 20.226 9.73571 16.35C9.73571 12.474 12.8517 9.472 16.9177 9.472C18.7322 9.472 20.3092 10.0515 21.5727 11.0585L19.9767 13.3765C19.1312 12.7115 18.1527 12.208 16.9177 12.208Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_201_110",
    x: 7.73572,
    y: 9.472,
    width: 16.0649,
    height: 17.756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_201_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_201_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.cf67b5dfd460f56d6e6e1544b212510b.svg";
export { ForwardRef as ReactComponent };